export default __webpack_public_path__ + "static/media/pf.66b47a89.svg";